import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=2ad87356&"
import script from "./MemberList.vue?vue&type=script&lang=js&"
export * from "./MemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports